import { SalaryInfo } from './SalaryInfo.main';

export { SalaryInfo };
